import React from 'react'

import { defaultClassName } from './constants'

export interface FluentFlexContextProps {
  itemClassName: string
}

export const FluentFlexContext = React.createContext<FluentFlexContextProps>({
  itemClassName: defaultClassName,
})
